import { render, staticRenderFns } from "./StatesStatisticsBlock.vue?vue&type=template&id=6942aad8&scoped=true&"
import script from "./StatesStatisticsBlock.vue?vue&type=script&lang=js&"
export * from "./StatesStatisticsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942aad8",
  null
  
)

export default component.exports